import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["cart", "membership_service_usable_credit_data", "singlesSubServiceAppointments", "applied_vouchers", "is_apply_free_service_voucher_addon", "is_apply_free_service_voucher_addanother"].includes(value) 
        && values[value] 
        && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  
  const action = "afterlogin/sale/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  if(localStorage.getItem('hasAutomationAccess')==1){
    formData.append("automationProcess", 1);
  }
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["cart"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/sale/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  const action = page ? `afterlogin/sale/view?page=${page}&${sortstring}` : `afterlogin/sale/view?${sortstring}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : "",
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}` : API_URL + action, data, { headers: authHeader() });
};

const invoiceview = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  const formName = values && values.formName ? values.formName : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/invoice?page=${page}&${sortstring}&q=${q}` : `afterlogin/sale/invoice?${sortstring}&q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    singlestaffaccess : values && values.singlestaffaccess ? values.singlestaffaccess : "",
    client_id: values && values.client_id ? values.client_id : "",
    daterange: values && values.daterange ? values.daterange : "",
    result: result, //business_name,owner_name
    formName: formName, //business_name,owner_name
    option: values && values.option ? values.option : "",
    apicall: "suggetion",
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}&q=${q}` : API_URL + action, data, { headers: authHeader() });
};

const createinvoiceview = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  const formName = values && values.formName ? values.formName : "";
  const clickEvent = values && values.clickEvent ? values.clickEvent : "";
  const id = values && values.id ? values.id : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
    if(clickEvent){
      pagination = false;
    }
  }
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/createinvoice?page=${page}&${sortstring}&q=${q}` : `afterlogin/sale/createinvoice?${sortstring}&q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    id:id,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    client_id: values && values.client_id ? values.client_id : "",
    daterange: values && values.daterange ? values.daterange : "",
    result: result, //business_name,owner_name
    formName: formName, //business_name,owner_name
    option: values && values.option ? values.option : "",
    singlestaffaccess : values && values.singlestaffaccess ? values.singlestaffaccess : "",
    apicall: "suggetion",
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}&q=${q}` : API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/sale/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const suggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/view?page=${page}&q=${q}` : `afterlogin/sale/view?q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall: "suggetion",
  };
  return axios.post(next_page_url ? `${next_page_url}&q=${q}` : API_URL + action, data, { headers: authHeader() });
};

const services = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let service_id = values && values.service_id ? values.service_id : "";
  let staff = values && values.staff ? values.staff : "";
  let gprice = values && values.gprice ? values.gprice : "";
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/services?page=${page}&service_id=${service_id}&q=${q}` : `afterlogin/sale/services?service_id=${service_id}&q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    staff: staff,
    gprice: gprice,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const products = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let product_id = values && values.product_id ? values.product_id : "";
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/products?page=${page}&product_id=${product_id}&q=${q}` : `afterlogin/sale/products?product_id=${product_id}&q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    page_type : values && values.page_type ? values.page_type : ""
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const vouchers = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let voucher_id = values && values.voucher_id ? values.voucher_id : "";
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/vouchers?page=${page}&voucher_id=${voucher_id}&q=${q}` : `afterlogin/sale/vouchers?voucher_id=${voucher_id}&q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    voucher_to: values,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const membership = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let membership_id = values && values.membership_id ? values.membership_id : "";
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/membership?page=${page}&membership_id=${membership_id}&q=${q}` : `afterlogin/sale/membership?membership_id=${membership_id}&q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const subscription = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let subscription_id = values && values.subscription_id ? values.subscription_id : "";
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/subscription?page=${page}&subscription_id=${subscription_id}&q=${q}` : `afterlogin/sale/subscription?subscription_id=${subscription_id}&q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const clientsuggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/client/view?page=${page}&q=${q}` : `afterlogin/client/view?q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    role_id: 6,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall: "suggetion",
  };
  return axios.post(next_page_url ? `${next_page_url}&q=${q}` : API_URL + action, data, { headers: authHeader() });
};

const sendEmailInvoice = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/sale/sendEmailInvoice";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  formData.append("formName", values?.fomName);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};
const voucherapply = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();

  for (let value in values) {
    if (value === 'service_ids') {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }

  const action = "afterlogin/sale/voucherapply";
  formData.append("auth_key", auth_key);
  formData.append("action", action);

  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const returnpayment = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/sale/returnpayment";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const sendemailvoucher = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/sale/sendemailvoucher";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const saleservicesmanage = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["cart", "client"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/sale/servicesmanage";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};



const saledetails = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  const formName = values && values.formName ? values.formName : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  let q = values && values.q ? values.q : "";
  const action = page ? `afterlogin/sale/invoice?page=${page}&${sortstring}&q=${q}` : `afterlogin/sale/invoice?${sortstring}&q=${q}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    singlestaffaccess : values && values.singlestaffaccess ? values.singlestaffaccess : "",
    client_id: values && values.client_id ? values.client_id : "",
    daterange: values && values.daterange ? values.daterange : "",
    result: result, //business_name,owner_name
    formName: formName, //business_name,owner_name
    option: values && values.option ? values.option : "",
    apicall: "suggetion",
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}&q=${q}` : API_URL + action, data, { headers: authHeader() });
};

const productstafflist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const dropdown = values && values.dropdown ? values.dropdown : "";
  const result = values && values.result ? values.result : "";
  const product_id = values && values.product_id ? values.product_id : "";
  const pagetype = values && values.pagetype ? values.pagetype : "";
  const action = `afterlogin/staff/view`;
  
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false,
    id: "",
    result: result, //business_name,owner_name
    pagetype: pagetype,
    option: values && values.option ? values.option : "",
    page_name: values && values.page_name ? values.page_name : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const subscriptionstafflist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const dropdown = values && values.dropdown ? values.dropdown : "";
  const result = values && values.result ? values.result : "";
  const product_id = values && values.product_id ? values.product_id : "";
  const pagetype = values && values.pagetype ? values.pagetype : "";
  const action = `afterlogin/staff/view`;
  
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false,
    id: "",
    result: result, //business_name,owner_name
    pagetype: pagetype,
    option: values && values.option ? values.option : "",
    page_name: values && values.page_name ? values.page_name : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deactivateinvoice = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = "afterlogin/sale/deactivateinvoice";
  const data = {
    auth_key: auth_key,
    action: action,
    id: values && values.id ? values.id : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const activitylog = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const routeAction = "afterlogin/sale/activitylog";
  const page = values && values.page ? values.page : "";
  const url = page ? `${routeAction}?page=${page}` : routeAction;
  const data = {
    auth_key: auth_key,
    action: routeAction,
    pagination: values && typeof values.pagination !== "undefined" ? values.pagination : true,
    limit: values && values.limit ? values.limit : 20,
    sale_id: values && values.sale_id ? values.sale_id : "",
    created_by: values && values.created_by ? values.created_by : "",
    daterange: values && values.daterange ? values.daterange : "",
    log_action: values && values.log_action ? values.log_action : "",
  };
  return axios.post(API_URL + url, data, { headers: authHeader() });
};

const saleApiController = {
  create,
  saledetails,
  update,
  view,
  deleted,
  suggetionlist,
  services,
  products,
  vouchers,
  membership,
  subscription,
  invoiceview,
  createinvoiceview,
  clientsuggetionlist,
  sendEmailInvoice,
  voucherapply,
  returnpayment,
  sendemailvoucher,
  saleservicesmanage,
  productstafflist,
  subscriptionstafflist,
  deactivateinvoice,
  activitylog,
};
export default saleApiController;
